import { defineMessages } from 'react-intl';

export default defineMessages({
  MyComplementaryHealthCoverageTitle: {
    id: 'amc_details.my_contracts_bloc.my_complementary_health_coverage_title',
  },
  wire: {
    id: 'amc.details.wire',
  },
  mandat: {
    id: 'amc.details.mandat',
  },
  base: {
    id: 'refund.type.base',
  },
  complementaire: {
    id: 'refund.type.complementaire',
  },
  suiviPac: {
    id: 'pac.suivi.declaration.button.title',
  },
  suiviPacShort: {
    id: 'amc_details.suivi.pac.short.title',
  },
});
